<template>
  <div class="banner_container">
    <v-alert
      :value="true"
      :type="type"
      class="notranslate"
    ><slot></slot></v-alert>
    <v-btn v-if="buttonText"
           large
           depressed
           :color="type"
           :href="typeof action === 'string' ? action : undefined"
           :target="typeof action === 'string' ? '_blank' : undefined"
           @click="btnClick"
           v-html="buttonText"
    ></v-btn>
  </div>
</template>

<script>
import VAlert from 'vuetify/es5/components/VAlert/VAlert'
import VBtn from 'vuetify/es5/components/VBtn/VBtn'
export default {
  name: 'Banner',
  components: {
    VAlert,
    VBtn
  },
  props: {
    type: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: false
    },
    action: {
      required: false
    }
  },
  methods: {
    btnClick: function () {
      if (typeof this.action === 'function') this.action()
    }
  }
}
</script>

<style scoped lang="scss">
    .banner_container {
      display: flex;
      align-items: center;
      .v-alert {
        flex: 1;
        margin: 0;
      }
      .v-btn {
        padding: 0 18px;
        margin: 0 0 0 12px;
      }
    }
</style>
